import { render, staticRenderFns } from "./scrolldown-secondary.vue?vue&type=template&id=5c66d461&scoped=true&"
import script from "./scrolldown-secondary.vue?vue&type=script&lang=js&"
export * from "./scrolldown-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66d461",
  null
  
)

export default component.exports